import { Icon } from '@monobits/components'
import { useComponent } from '../hooks'

const Icons = ({ name, ...props }) => {
  const { icons } = useComponent() ?? {}
  return name in icons && <Icon icon={icons[name]} {...props} />
}

export default Icons
